








import Vue from 'vue';
import {
  mapState,
  mapActions
} from 'vuex';
import store from '../store/index';
import { getQueryVariable } from '../common/common';
import FullTextMark from '../components/FullTextMark.vue';
import ReportFooter from '../components/ReportFooter.vue';
import Explain from '../components/Explain.vue';

export default Vue.extend({
  name: 'FullText',
  computed: mapState({
    reportType: (state: any) => store.getters.getReportType,
    checkInfo: (state: any) => store.getters.getCheckInfo,
    checkText: (state: any) => store.getters.getCheckText
  }),
  components: {
    FullTextMark,
    ReportFooter,
    Explain
  },
  data() {
    return {
      checkResult: {}
    };
  },
  methods: {
    // 获取检测报告数据
    getData() {
      if (JSON.stringify(this.checkInfo) === '{}') {
        this.$store.dispatch('setCheckInfo');
      }
      if (!this.checkText) {
        this.$store.dispatch('setCheckText');
      }
    }
  },
  mounted() {
    this.getData();
  }
});
